(function(){
    'use strict'

    angular.module('app.core')
    .factory('ApiBaseService', ApiBaseService);

    ApiBaseService.$inject = ['$http', '$q', 'apiSettings'];

    function ApiBaseService($http, $q, apiSettings) {

        const api = {
            getAll: getAll,
            getFile: getFile,
            getById: getById,
            getNombreByCedula: getNombreByCedula,
            save: save,
            update:update,
            remove: remove,
            remoteController: ''
        };


        return api;

        function getStringParams(params){
            let stringParams = '';
            if(params != undefined && params != null)
            {
                params.forEach(element => {
                    stringParams += `/${element}`
                });
            }
            return stringParams;
        };

        function getAll(params){


            var url = `${apiSettings.apiBaseUrl}${api.remoteController}${getStringParams(params)}`;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getFile(params){

            var url = `${apiSettings.apiBaseUrl}${api.remoteController}${getStringParams(params)}`;
            
            return $http.get(url, {responseType: 'arraybuffer'})
            .then(function (response) {
                
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
        
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
        
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                    
                } catch (ex) {
                    console.log(ex);
                }

                return response;

            }).catch(function (data) {
                return $q.reject(data);
            });
        };

        function getById(id){

            var url = `${apiSettings.apiBaseUrl}${api.remoteController}/${id}`;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        async function getNombreByCedula(cedula){
            try {
                var url = `${apiSettings.apiGometaBaseUrl}cedulas/${cedula}`;

                const response = await fetch(url);

                return response.json();

            } catch (error) {
                return null;
            }
        };

        function save(data){

            data.id = 0;

            var response = $http({  
                url: `${apiSettings.apiBaseUrl}${api.remoteController}`,  
                method: 'POST',  
                data: data
            });  
            return response;
        };

        function update(data){

            var response = $http({  
                url: `${apiSettings.apiBaseUrl}${api.remoteController}`,  
                method: 'PUT',  
                data: data
            });  
            return response;
        };

        function remove(data){

            var response = $http({  
                url: `${apiSettings.apiBaseUrl}${api.remoteController}`,  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: data
            });  
            return response;
        };

    };

})();